import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { POST, httpOk } from 'helpers/api'

/**
 * Пополнение справочника ИКПУ из tasnif.soliq.uz.
 *
 * Ручка ищет по коду или названию и складывает всё найденное вместе с
 * упаковками в общий справочник. Раньше повторный поиск того же кода
 * добавлял его копию, поэтому в ответе теперь отдельно видно, сколько
 * записей добавилось, а сколько уже было.
 */
function FiscalCodesTab() {
	const { t } = useTranslation()

	const [fiscalCode, setFiscalCode] = useState('')
	const [result, setResult] = useState(null)

	async function createFiscalCode(e) {
		e.preventDefault()

		if (!fiscalCode.trim()) {
			toast.error(t('admin_tools_fiscal_required'))
			return
		}

		setResult(null)
		const response = await POST('/admin/fiscal-code', {
			'fiscal_code': fiscalCode.trim(),
		}, { loader: true, notification: false })

		if (httpOk(response)) {
			setResult(response.data)
			toast.success(response.data?.message || t('success'))
		}
	}

	return (
		<div className="row">
			<div className="col-md-6">
				<div className="card">
					<div className="card-body">
						<div className="tool-section-title">
							{t('admin_tools_fiscal_codes')}
						</div>
						<div className="text-muted fz-12 mb-3">
							{t('admin_tools_fiscal_hint')}
						</div>

						<form autoComplete="off" onSubmit={createFiscalCode}>
							<div className="form-group">
								<label>{t('admin_tools_fiscal_search')}</label>
								<input type="text" className="form-control"
									value={fiscalCode} autoComplete="off"
									placeholder={t('admin_tools_fiscal_placeholder')}
									onChange={(e) => setFiscalCode(e.target.value)} />
							</div>

							<button type="submit" className="btn btn-primary w-100 mt-2">
								{t('add')}
							</button>
						</form>

						{result &&
							<div className="tool-result mt-3">
								<div className="tool-result-row">
									<span>{t('admin_tools_codes_created')}</span>
									<b className="text-success">{result.codes_created ?? 0}</b>
								</div>
								<div className="tool-result-row">
									<span>{t('admin_tools_codes_skipped')}</span>
									<b className="text-muted">{result.codes_skipped ?? 0}</b>
								</div>
								<div className="tool-result-row">
									<span>{t('admin_tools_packages_created')}</span>
									<b className="text-success">{result.packages_created ?? 0}</b>
								</div>
							</div>
						}
					</div>
				</div>
			</div>
		</div>
	)
}

export default FiscalCodesTab
